import { useEffect, useRef } from "react";

export function useInterval(callback, delay, dependencies) {
  // Create reference in order to save the current last callback
  const savedCallback = useRef();

  /*
   * With this code we store the last callback executed.
   * If it change we store again in order to get always the last callback executed and be unique by react reference
   */
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  /*
   * We set the interval calling on each tick the saved callback reference.
   */
  useEffect(() => {
    let id = setInterval(savedCallback.current, delay); // Set the interval calling the current stored callback tick
    return () => clearInterval(id); // clean interval in order to remove interval on destroy component
  }, [dependencies]); // pass the respective dependencies
}
